import Users from '~/views/layouts/Users.jsx';
import View from '~/views/layouts/UserView/containers/UserView.jsx';
import Edit from '~/views/layouts/UserForm/containers/Edit.jsx';
import NotFound from '~/views/common/StatusCodes.jsx';


import SubRoutes from './components/SubRoutes.jsx';
import requireAuth from '~/views/enhancers/requireAuth.jsx';


export default [
    {
        path: '/users',
        exact: true,
        component: requireAuth(Users),
    },
    {
        path: '/users/:id',
        component: requireAuth(SubRoutes),
        routes: [
            {
                path: '/users/:id',
                exact: true,
                component: View,
            },
            {
                path: '/users/:id/edit',
                exact: true,
                component: Edit,
            },
            {
                path: '*', component: NotFound,
            },
        ],
    },
];
